import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

export default function ApplicationFunnel({ funnelData = [] }) {
  const series = useMemo(() => [{
    name: "Applications",
    data: funnelData.map(item => item.applications),
  }], [funnelData]);

  const options = useMemo(() => ({
    chart: {
      type: "bar",
      height: 400,
      toolbar: { show: false },
      animations: {
        enabled: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        barHeight: "75%",
        isFunnel: true,
      },
    },
    colors: funnelData.map(item => item.color || "#6B7280"),
    dataLabels: {
      enabled: true,
      formatter: (val) => val.toLocaleString(),
      style: {
        fontSize: "12px",
        fontWeight: "500",
        colors: ["#374151"]
      },
      dropShadow: { enabled: false }
    },
    xaxis: {
      categories: funnelData.map(item => item.stage),
      labels: {
        show: false,
      },
    },
    yaxis: {
      show: true,
      labels: {
        show: true,
        align: 'right',
        minWidth: 120,
        maxWidth: 160,
        style: {
          colors: funnelData.map(() => "#4B5563"),
          fontSize: "14px",
          fontWeight: 600,
          fontFamily: 'Outfit, sans-serif',
        },
        offsetX: -10,
      },
    },
    grid: {
      show: false,
      padding: {
        left: 60,
        right: 20,
        top: -10,
        bottom: 0
      }
    },
    legend: { show: false },
    tooltip: {
      enabled: true,
      y: {
        formatter: val => `${val.toLocaleString()} applications`
      },
    },
  }), [funnelData]);

  if (!funnelData || funnelData.length === 0) {
    return (
      <div style={{ padding: "40px", textAlign: "center", color: "#999" }}>
        No funnel data available
      </div>
    );
  }

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div style={{ textAlign: "center", marginBottom: "15px" }}>
        <p style={{ fontFamily: 'Inter-Medium', color: '#667085', fontSize: '25px' }}>Applications Funnel</p>
      </div>

  
      <div style={{
        position: "absolute",
        left: "10px",
        top: "65px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        height: "calc(100% - 80px)",
        pointerEvents: "none",
        zIndex: 10
      }}>
        {funnelData.map((item, idx) => (
          <div
            key={idx}
            style={{
              fontFamily: 'Outfit, sans-serif',
              fontSize: "14px",
              fontWeight: 600,
              color: "#2c3e50",
              textAlign: "right",
              paddingRight: "8px",
              whiteSpace: "nowrap"
            }}
          >
            {item.stage}    
          </div>
        ))}
      </div>

      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={350}
      />
    </div>
  );
}